import { render, staticRenderFns } from "./PrintArticles.vue?vue&type=template&id=65999378&scoped=true"
import script from "./PrintArticles.vue?vue&type=script&lang=js"
export * from "./PrintArticles.vue?vue&type=script&lang=js"
import style0 from "./PrintArticles.vue?vue&type=style&index=0&id=65999378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65999378",
  null
  
)

export default component.exports